import { render, staticRenderFns } from "./behavior.vue?vue&type=template&id=6b6934bc&scoped=true&"
import script from "./behavior.vue?vue&type=script&lang=js&"
export * from "./behavior.vue?vue&type=script&lang=js&"
import style0 from "./behavior.vue?vue&type=style&index=0&id=6b6934bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6934bc",
  null
  
)

export default component.exports